<template>
  <div class="dp-search-modal" :class="{ 'with-results': resultsOpened }">
    <fpui-modal>
      <fpui-modal-body>
        <div class="search-container">
          <fpui-input-search
            v-model="searchQuery"
            :autocomplete="routes"
            :onAutocompleteSelection="onSelection"
            :autocompleteCloseOnEsc="false"
            @autocomplete-visible='visible => resultsOpened = visible'
            autofocus
          >
          </fpui-input-search>
        </div>
      </fpui-modal-body>
    </fpui-modal>
  </div>
</template>

<script>
import allRoutes from '@/shared/components/searchbar/allRoutes'

export default {
  data () {
    return {
      searchQuery: '',
      resultsOpened: false,
      config: null
    }
  },
  computed: {
    organizationId () {
      return this.$route.params.organizationId || this.$store.getters.ACTIVE_ORGANIZATION()?._id
    },
    routes () {
      return Object.entries(allRoutes).flatMap(([service, serviceContent]) => {
        const category = this.$t(`searchbar.items.${service}.category`) || service
        return serviceContent.routes.map(route => {
          const path = this.createPath(serviceContent.basePath, route.path)
          const href = service === 'core' ? path : `/${path}`
          const display_name = this.$t(route.display_name)
          const description = this.$t(route.description) || null

          return {
            value: route,
            label: route.name,
            display_name,
            service,
            href,
            description,
            category
          }
        })
      })
    }
  },
  methods: {
    createPath (base, path) {
      const params = {
        ...this.$route.params,
        dataplantId: this.$route.params.dataplantId || this.$route.params.projectId,
        projectId: this.$route.params.projectId || this.$route.params.dataplantId,
        organizationId: this.organizationId
      }
      const replacedPath = path.replace(/:([A-Za-z0-9_]+)/g, (_, key) => params[key] || `:${key}`)
      if (base === 'core') return `/#${replacedPath}`
      return `${base}#${replacedPath}`
    },
    onSelection (selection) {
      // Go to the href link
      window.location.href = selection.href
      this.$emit('close')
    }
  }
}
</script>

<style lang='less'>
.dp-search-modal {
  margin-top: 70px;
  .fpui-modal {
    border-radius: 14px;
    background-color: transparent;
    .modal-body {
      padding: 0;
      .search-container {
        .fpui-input-search {
          i.fp4.fp4-magnifying-glass {
            line-height: 60px;
            font-size: 32px;
            height: 60px;
            width: 50px;
            cursor: grab;
            &::before {
              font-size: 24px;
              transition: color 500ms;
            }
            &:active {
              cursor: grabbing;
            }
          }
          .fpui-input-text {
            .fpui-input-text-content {
              input {
                background-color: fade(white, 60%);
                height: 60px;
                font-size: 24px;
                padding-left: 50px !important;
                border-radius: 14px;
                border: none;
                transition: none;
                &:focus {
                  border: none;
                }
              }
            }
            ul.autocomplete {
              position: relative;
              border-radius: 0 0 14px 14px;
              background-color: fade(white, 60%);
              max-height: 50vh;
              overflow-y: scroll;
              padding: 0 16px;
              box-shadow: none;
              li {
                background-color: transparent;
                border-radius: 14px;
                .autocomplete-value {
                  font-weight: 600;
                  font-size: 18px;
                }
                .autocomplete-description {
                  color: fade(black, 40%);
                  font-size: 16px;
                  font-style: normal;
                }
                &.category-header {
                  margin-bottom: 5px;
                  &:not(:first-child) {
                    margin-top: 5px;
                  }
                }
                &:hover {
                  background-color: transparent !important;
                }
                &.disabled {
                  background-color: rgba(151, 167, 183, 0.15) !important;
                }
                &.selected, &:active:not(.category-header) {
                  background-color: fade(darken(rgb(0, 204, 249), 5%), 90%) !important;
                  .autocomplete-value {
                    color: white;
                  }
                  .autocomplete-description {
                    color: fade(white, 80%);
                  }
                }
                &:first-child {
                  margin-top: 16px;
                }
                &:last-child {
                  margin-bottom: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
  &.with-results {
    .fpui-modal {
      .modal-body {
        .search-container .fpui-input-search .fpui-input-text .fpui-input-text-content input {
          border-radius: 14px 14px 0 0;
        }
      }
    }
  }
}
</style>
